import FeatherIcon from 'feather-icons-react';
import React, { Fragment, useState } from 'react';

/** Brand sidebar accents (hover = mint, active = coral) */
const SIDEBAR_HOVER_ACCENT = '#A3E3D8';
const SIDEBAR_ACTIVE_ACCENT = '#F27062';
const SIDEBAR_ACTIVE_BG = 'rgba(242, 112, 98, 0.12)';
const SIDEBAR_HOVER_BG = 'rgba(255, 255, 255, 0.06)';

const NavigationItem = ({
  label,
  active,
  icon,
  onClick,
  hasChildren,
  children,
  id,
  hover,
  hasSvg,
  svg,
  expandedCategories = []
}) => {


  const [isHovered, setIsHovered] = useState(false);
  const [hoveredChildId, setHoveredChildId] = useState(null);
  const isExpanded = expandedCategories.includes(id);

  const isActive = active === id;

  return (
    <>
      <div
        className={`tw-w-full tw-h-[40px] tw-flex tw-flex-row tw-cursor-pointer tw-transition-colors tw-duration-150`}
        style={{
          borderLeft: isActive
            ? `3px solid ${SIDEBAR_ACTIVE_ACCENT}`
            : isHovered && !isActive
              ? `3px solid ${SIDEBAR_HOVER_ACCENT}`
              : '3px solid transparent',
          backgroundColor: isActive ? SIDEBAR_ACTIVE_BG : isHovered ? SIDEBAR_HOVER_BG : 'transparent',
        }}
        onClick={onClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className='tw-flex tw-gap-2'>
          <div
            className='tw-flex tw-flex-row tw-items-center tw-justify-center tw-w-[40px]'
            style={{
              backgroundColor: isActive && !hover ? SIDEBAR_ACTIVE_BG : 'transparent',
            }}
          >
            {hasSvg ?
            <img
            src={svg}
            alt=""
            style={{
              width: '16px',
              height: '16px',
              filter: isActive ? "brightness(0) invert(1)" : "brightness(0) invert(1) opacity(0.7)",
            }}
          />
              :
              <FeatherIcon
                icon={icon}
                size={'16px'}
                style={{
                  color: isActive ? '#FFFFFF' : 'rgba(255, 255, 255, 0.7)',
                }}
              />
            }
          </div>
          <div className='tw-flex tw-items-center tw-overflow-hidden'>
            <p
              className="tw-text-[14px] tw-font-sans tw-font-medium tw-py-auto tw-whitespace-nowrap tw-transition-all tw-duration-300"
              style={{
                color: isActive ? '#FFFFFF' : 'rgba(255, 255, 255, 0.8)',
                fontWeight: isActive ? 600 : 500,
                opacity: hover ? 1 : 0,
                transform: hover ? 'translateX(0)' : 'translateX(-8px)',
              }}
            >
              {label}
            </p>
          </div>
        </div>
        {hasChildren && (
          <div
            className='tw-flex tw-items-center tw-ms-auto tw-pe-[8px] tw-transition-opacity tw-duration-300'
            style={{ opacity: hover ? 1 : 0 }}
          >
            <div
              className={`sidebar-nav-group-chevron ${isExpanded ? 'sidebar-nav-group-chevron--expanded' : ''}`}
            >
              <FeatherIcon
                icon="chevron-down"
                size={'16px'}
                style={{
                  color: isActive
                    ? SIDEBAR_ACTIVE_ACCENT
                    : isExpanded
                      ? SIDEBAR_HOVER_ACCENT
                      : 'rgba(255, 255, 255, 0.5)',
                }}
              />
            </div>
          </div>
        )}
      </div>
      {hasChildren && hover && (
        <div
          className={`sidebar-nav-group-children ${isExpanded ? 'sidebar-nav-group-children--expanded' : ''}`}
        >
          {children &&
            children.map((child, index) => {
              if (child.hasChildren && child.children?.length) {
                const subExpanded = expandedCategories.includes(child.id);
                return (
                  <Fragment key={child.id || index}>
                    <div
                      className={`tw-min-h-[36px] tw-flex tw-flex-row tw-items-center tw-cursor-pointer tw-rounded tw-transition-colors tw-duration-150 tw-px-2 tw-pe-1 hover:tw-bg-gray-100`}
                      style={{ position: 'relative', zIndex: 10 }}
                      onClick={(e) => {
                        e.stopPropagation();
                        child.onClick();
                      }}
                    >
                      <svg
                        style={{
                          position: 'absolute',
                          left: '-24px',
                          top: '0',
                          height: '36px',
                          overflow: 'visible'
                        }}
                        width="24"
                        height="36"
                        viewBox="0 0 24 36"
                        preserveAspectRatio="none"
                      >
                        <path
                          d="M 1,0 L 1,12 Q 1,18 7,18 L 24,18"
                          fill="none"
                          stroke="#D1D5DB"
                          strokeWidth="2"
                          strokeLinecap="round"
                          vectorEffect="non-scaling-stroke"
                        />
                      </svg>
                      <p className="tw-text-[13px] tw-font-medium tw-font-sans tw-text-[#4B5563] tw-flex-1">
                        {child.label}
                      </p>
                      <FeatherIcon
                        icon={subExpanded ? 'chevron-up' : 'chevron-down'}
                        size="14px"
                        className={subExpanded ? 'tw-text-[#488E9D]' : 'tw-text-[#6C757D]'}
                      />
                    </div>
                    {subExpanded &&
                      child.children.map((leaf, leafIdx) => {
                        const isLeafActive = active === leaf.id;
                        return (
                          <div
                            key={leaf.id || leafIdx}
                            className={`tw-group tw-min-h-[36px] tw-flex tw-items-center tw-cursor-pointer tw-rounded tw-transition-colors tw-duration-150 tw-px-2 tw-ms-3 ${
                              isLeafActive ? 'tw-bg-[#E8F6F5]' : 'hover:tw-bg-gray-100'
                            }`}
                            style={{ position: 'relative', zIndex: 10 }}
                            onClick={(e) => {
                              e.stopPropagation();
                              leaf.onClick();
                            }}
                          >
                            <p
                              className={`tw-text-[13px] tw-font-medium tw-font-sans tw-transition-colors ${
                                isLeafActive
                                  ? 'tw-text-[#488E9D]'
                                  : 'tw-text-[#6B7280] group-hover:tw-text-[#488E9D]'
                              }`}
                            >
                              {leaf.label}
                            </p>
                          </div>
                        );
                      })}
                  </Fragment>
                );
              }

              const isChildActive = active === child.id;
              const isChildHovered = hoveredChildId === child.id && !isChildActive;
              return (
                  <div 
                    key={child.id || index} 
                    className='tw-h-[36px] tw-flex tw-items-center tw-cursor-pointer tw-rounded tw-transition-colors tw-duration-150 tw-px-2'
                    style={{
                      position: 'relative',
                      zIndex: 10,
                      borderLeft: isChildActive
                        ? `3px solid ${SIDEBAR_ACTIVE_ACCENT}`
                        : isChildHovered
                          ? `3px solid ${SIDEBAR_HOVER_ACCENT}`
                          : '3px solid transparent',
                      backgroundColor: isChildActive
                        ? SIDEBAR_ACTIVE_BG
                        : isChildHovered
                          ? SIDEBAR_HOVER_BG
                          : 'transparent',
                    }}
                    onClick={child.onClick}
                    onMouseEnter={() => setHoveredChildId(child.id)}
                    onMouseLeave={() => setHoveredChildId(null)}
                >
                  <span
                    style={{
                      width: 3,
                      height: 3,
                      borderRadius: '50%',
                      backgroundColor: isChildActive
                        ? SIDEBAR_ACTIVE_ACCENT
                        : isChildHovered
                          ? SIDEBAR_HOVER_ACCENT
                          : 'rgba(255, 255, 255, 0.25)',
                      flexShrink: 0,
                    }}
                  />
                  <p
                    className='tw-text-[13px] tw-font-sans tw-transition-colors'
                    style={{
                      color: isChildActive
                        ? '#fff'
                        : isChildHovered
                          ? 'rgba(255, 255, 255, 0.8)'
                          : 'rgba(255, 255, 255, 0.4)',
                      fontWeight: isChildActive ? 600 : 500,
                      marginLeft: '8px',
                    }}
                  >
                    {child.label}
                  </p>
                </div>
              );
            })}
        </div>
      )}
    </>
  );
};

export default NavigationItem;
